import store from '@/stores';

import FGTSList from '@/views/fgts/FGTSList.vue';

const name = 'fgts';
const path = '/fgts';

const switchTo = (to, from, next) => {
  const isNewVersion = to.name.includes('new');
  const viewVersion = store.state.consult.consult_view_version;

  if (viewVersion === 'new' && !isNewVersion) {
    return next({ name: `${name}-consult-new` });
  }

  next();
};

export default [
  // routes
  {
    name: `${name}-proposal`,
    path: `${path}/propostas`,
    component: FGTSList,
  },
  {
    name: `${name}-consult`,
    path: `${path}/consultar`,
    component: () => import('@/views/fgts/FGTSConsult.vue'),
    beforeEnter: (to, from, next) => {
      switchTo(to, from, next, 'new');
    },
  },
  {
    name: `${name}-consult-new`,
    path: `${path}/consultar/novo`,
    component: () => import('@/views/fgts/FGTSConsultRedesign.vue'),
    beforeEnter: (to, from, next) => {
      switchTo(to, from, next, 'old');
    },
  },
  {
    name: `${name}-reserve`,
    path: `${path}/reservar`,
    component: () => import('@/views/ReservationList.vue'),
  },
  {
    name: `${name}-mass-consult`,
    path: `${path}/consultar/lote`,
    component: () => import('@/views/fgts/FGTSMassConsult.vue'),
  },
  {
    name: `${name}-new`,
    path: `${path}/novo`,
    component: () => import('@/views/fgts/FGTSNewProposal.vue'),
  },
  {
    name: `${name}-mass-consult-historic`,
    path: `${path}/consultar/lote/historico`,
    component: () => import('@/views/fgts/FGTSMassConsultHistoric.vue'),
  },

  // redirects (legacy)
  {
    path: `${path}/consulta-por-lote`,
    redirect: `${path}/consultar/lote`,
  },
];
